import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: calc(50% - 10px); // subtract 10px for the flex gap

  &.disable {
    opacity: 0.5;
  }

  .upload {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--grey-0);
    border: 1.5px dashed var(--grey-2);
    background-color: var(--container-color);
    border-radius: 6px;
    padding-bottom: 20px;
    padding-top: 8px;
    transition: background 200ms eas-in-out;

    .import-icon {
      box-sizing: border-box;
      height: 38px;
      width: 36px;
      padding: 9px 8px 9px 8px;

      path {
        stroke: var(--grey-0);
      }
    }

    p {
      font-family: "Inter";
      font-weight: 500;
    }

    .upload-link {
      margin-top: 10px;
    }

    a {
      color: var(--grey-0);
      text-decoration: underline;
    }
  }

  .rejected {
    border-color: var(--danger-color);
    background-color: rgba(255, 88, 98, 0.1);
  }

  .accepted {
    border-color: var(--primary-cta-high-contrast);
    background-color: var(--primary-cta-transparent-15);
  }
`;
